export const MultiSelectEventType = {
  Click: 'click',
  Change: 'change',
};

export const MultiSelectProperty = {
  Value: 'value',
  Label: 'label',
  Id: 'id',
  Options: 'options',
  NoOptionsPlaceholder: 'noOptionsPlaceholder',
  CheckboxIconSize: 'checkboxIconSize',
  IconColor: 'iconColor',
  ColorScheme: 'colorScheme',
  LabelColorScheme: 'labelColorScheme',
  FillType: 'fillType',
  Disabled: 'disabled',
  IsReadonly: 'isReadonly',
  ErrorMessage: 'errorMessage',
  IsShowErrorMessage: 'isShowErrorMessage',
};

export default {
  MultiSelectEventType,
  MultiSelectProperty,
};
